import { render, staticRenderFns } from "./TVPage.vue?vue&type=template&id=475777ce&"
import script from "./TVPage.vue?vue&type=script&lang=js&"
export * from "./TVPage.vue?vue&type=script&lang=js&"
import style0 from "./TVPage.vue?vue&type=style&index=0&id=475777ce&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports